import { AppTheme } from 'common/interfaces';

export const color_primary = '#FF2B2B';
export const color_secondary = color_primary;

export const DEFAULT_VIEWMAP = '0dea5915c7a8c419sloookjba14db72d85c12553';

export const DEFAULT_LOGO_PATH = 'https://next.thezone.bg/channel-logos/test-350_thezone.png';
export const DEFAULT_LEFT_LOGO_PATH =
  'https://next.thezone.bg/channel-logos/test-350-left_thezone.png';

export const WHITELABEL_TYPE = AppTheme.LINEAR;
